/*--------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * See License.txt in the project root for license information.
 *--------------------------------------------------------------*/

import * as React from 'react';

export interface IAccountProfileEditLabel {
    id: string;
    forId: string;
    className: string;
    text: string;
}

const AccountProfileEditLabel: React.FC<IAccountProfileEditLabel> = ({ id, forId, className, text }) => (
    <label id={`${id}_label`} className={`${className}-label`} htmlFor={forId}>
        {text}
    </label>
);

export default AccountProfileEditLabel;
